import { addClass, removeClass } from '../../../../core/utils/src/dom';
function calculateAvailableSpace(trigger, scrollableParent, viewport) {
    // We want to leave some empty space before we reach the window
    var PADDING = 50;
    var left = trigger.right - Math.max(scrollableParent.left, 0) - PADDING;
    var top = trigger.top - Math.max(scrollableParent.top, 0) - PADDING;
    var bottom = Math.min(viewport.height, scrollableParent.bottom) - trigger.bottom - PADDING;
    var right = Math.min(viewport.width, scrollableParent.right) - trigger.left - PADDING;
    return { left: left, top: top, right: right, bottom: bottom };
}
export var scrollToHighlightedOption = function (dropdown) {
    if (!dropdown) {
        return;
    }
    var highlightedOption = dropdown.querySelector('.awsui-button-dropdown-item-highlighted');
    if (!highlightedOption) {
        return;
    }
    dropdown.scrollTop = highlightedOption.offsetTop;
};
function getOverflowParent(element) {
    var parent = element.parentElement;
    while (parent && getComputedStyle(parent).overflow === 'visible') {
        parent = parent.parentElement;
    }
    return parent || document.body;
}
var getAvailableSpace = function (componentRoot, triggerRect) {
    var scrollableParent = getOverflowParent(componentRoot).getBoundingClientRect();
    var viewport = { width: window.innerWidth, height: window.innerHeight };
    return calculateAvailableSpace(triggerRect, scrollableParent, viewport);
};
var getTargetPosition = function (target, componentRoot, triggerRect) {
    var targetRect = target.getBoundingClientRect();
    var space = getAvailableSpace(componentRoot, triggerRect);
    var horizontal = 'right';
    var vertical = 'bottom';
    if (space.right < targetRect.width && space.left > space.right) {
        horizontal = 'left';
    }
    if (space.bottom < targetRect.height && space.top > space.bottom) {
        vertical = 'top';
    }
    return {
        vertical: vertical,
        horizontal: horizontal,
        // dropdown should not be smaller than the button
        width: Math.min(space[horizontal], targetRect.width),
        height: space[vertical]
    };
};
var fitElement = function (target, triggerRect, componentRoot, setNoWrap, setTargetPosition) {
    // Remove size adjustments and measure dropdown without scrollbars, add min width
    setTargetPosition({ horizontal: 'right', vertical: 'bottom' });
    setNoWrap(true);
    // Once we determined normal dropdown width, we can enable text wrapping
    setTargetPosition(getTargetPosition(target, componentRoot, triggerRect));
    setNoWrap(false);
};
var DROP_CLASSES = {
    vertical: 'awsui-button-dropdown-drop-up',
    horizontal: 'awsui-button-dropdown-drop-left'
};
export var fitDropdown = function (dropdown, button) {
    var WRAPPED_CLASS_NAME = 'awsui-button-dropdown-wrapped';
    var setTargetPosition = function (props) {
        var firstChild = dropdown.firstChild;
        if (firstChild && props.height) {
            firstChild.style.maxHeight = props.height + "px";
        }
        props.vertical === 'top' && addClass(dropdown, DROP_CLASSES.vertical);
        props.horizontal === 'left' && addClass(dropdown, DROP_CLASSES.horizontal);
        if (props.width) {
            dropdown.style.width = props.width + "px";
            requestAnimationFrame(function () {
                var ulElement = dropdown.firstChild;
                if (ulElement) {
                    var scrollbarWidth = ulElement.offsetWidth - ulElement.scrollWidth;
                    if (scrollbarWidth) {
                        dropdown.style.width = props.width + scrollbarWidth + "px";
                    }
                }
            });
        }
    };
    var setNoWrap = function (noWrap) {
        if (noWrap) {
            removeClass(dropdown, WRAPPED_CLASS_NAME);
        }
        else {
            addClass(dropdown, WRAPPED_CLASS_NAME);
        }
    };
    var buttonRect = button.getBoundingClientRect();
    fitElement(dropdown, buttonRect, dropdown, setNoWrap, setTargetPosition);
};
export var fitFlyout = function (flyout, groupTrigger) {
    var WRAPPED_CLASS_NAME = 'awsui-button-dropdown-items-fly-out-wrapped';
    var parentContainer = groupTrigger;
    while (parentContainer.parentElement && parentContainer.tagName !== 'AWSUI-BUTTON-DROPDOWN') {
        parentContainer = parentContainer.parentElement;
    }
    var setTargetPosition = function (props) {
        if (flyout.style) {
            flyout.removeAttribute('style');
        }
        if (props.width) {
            flyout.style.width = props.width + "px";
        }
        var scrollableParent = groupTrigger.parentElement;
        // We need re-enabled wrapping and adjusted width to take effect, because
        // it would change the height of the flyout, messing up the top calculation
        requestAnimationFrame(function () {
            if (props.vertical === 'top') {
                flyout.style.top = groupTrigger.offsetTop +
                    groupTrigger.offsetHeight -
                    Math.min(flyout.offsetHeight, props.height) -
                    scrollableParent.scrollTop -
                    1 + "px";
            }
            else {
                flyout.style.top = groupTrigger.offsetTop - scrollableParent.scrollTop - 1 + "px";
            }
            flyout.style.maxHeight = props.height + "px";
        });
        if (props.width) {
            requestAnimationFrame(function () {
                var scrollbarWidth = flyout.offsetWidth - flyout.scrollWidth;
                if (scrollbarWidth) {
                    flyout.style.width = props.width + scrollbarWidth + "px";
                }
            });
        }
        if (props.horizontal === 'left') {
            flyout.style.right = '100%';
        }
        else {
            flyout.style.left = '100%';
        }
    };
    var setNoWrap = function (noWrap) {
        if (noWrap) {
            removeClass(flyout, WRAPPED_CLASS_NAME);
        }
        else {
            addClass(flyout, WRAPPED_CLASS_NAME);
        }
    };
    var groupRect = groupTrigger.getBoundingClientRect();
    var flippedRect = {
        right: groupRect.left,
        left: groupRect.right,
        bottom: groupRect.top,
        top: groupRect.bottom
    };
    fitElement(flyout, flippedRect, parentContainer, setNoWrap, setTargetPosition);
};
//# sourceMappingURL=dropdown-fit-handler.js.map